import {
  CreateUserActionPlansRequest,
  UserActionPlan,
} from "@/data/interfaces/UserActionPlan";
import { InsightType } from "@/data/interfaces/InsightType";
import { User } from "@/data/interfaces/User";
import api from "./api";

const userActionPlan = {
  getByUserId: async (userId: number) => {
    const resp = await api.get("/doctor/user-action-plans", {
      params: { user_id: userId },
    });
    return resp.data.data as UserActionPlan[];
  },
  create: async (data: CreateUserActionPlansRequest) => {
    const resp = await api.post("/doctor/user-action-plans/batch", data);
    return resp.data.data as UserActionPlan[];
  },
  update: async (id: number, data: { rules: string; insight_type_id: number }) => {
    const resp = await api.put(`/doctor/user-action-plans/${id}`, data);
    return resp.data.data as UserActionPlan;
  },
  delete: async (id: number) => {
    await api.delete(`/doctor/user-action-plans/${id}`);
  },
  deleteAll: async (userId: number) => {
    await api.delete(`/doctor/user-action-plans`, {
      data: { user_id: userId },
    });
  },
};

const getActionTypes = async () => {
  const resp = await api.get("/insight-types");
  return resp.data.data as InsightType[];
};

const patient = {
  search: async (params: { name?: string; email?: string }) => {
    const resp = await api.get("/users", { params });
    return resp.data.data as User[];
  },
};

export default {
  userActionPlan,
  getActionTypes,
  patient,
};
